module.exports = __webpack_public_path__ + "static/flags/GY-ad2bdb5cae1091677f5ff17e8ad848c6.gif";